<template>
    <span class="timepicker" @click="preventClosing = true">
        <input ref="input" type="text" :value="time" :class="inputClass" @blur="validate($refs.input.value)" @keydown="keydown" @input="input" @keydown.enter="validate()" @click="show()" @focus="show()" />

        <div class="timepicker-wrap hours" v-show="open" ref="dropdownHours" tabindex="-1">
            <ul class="timepicker-list">
                <li v-for="time in hourSuggestions">
                    <a href @click.prevent @mousedown.prevent="selectHour(time)"> {{ time }}</a>
                </li>
            </ul>
        </div>
        <div class="timepicker-wrap minutes" v-show="open" ref="dropdownMinutes" tabindex="-1">
            <ul class="timepicker-list">
                <li v-for="time in minuteSuggestions">
                    <a href @click.prevent @mousedown.prevent="selectMinute(time)"> {{ time }}</a>
                </li>
            </ul>
        </div>
    </span>
</template>

<style>
.timepicker {
    position: relative;
}

.timepicker-wrap {
    position: absolute;
    overflow-y: auto;
    height: 150px;
    width: 3.5em;
    background: #fff;
    border: 1px solid #ddd;
    outline: none;
    z-index: 10001;
    margin: 0;
}

.timepicker-wrap.hours {
    left: 0;
}

.timepicker-wrap.minutes {
    left: 3.5em;
}


.timepicker-wrap>ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

.timepicker-list li {
    padding: 0;
    cursor: pointer;
    white-space: nowrap;
    color: #000;
    list-style: none;
    margin: 0;
}

.timepicker-list li>a {
    padding: 5px 0 5px 5px;
    display: block;
}

.timepicker-list:hover .ui-timepicker-selected {
    background: #fff;
    color: #000;
}

li.ui-timepicker-selected,
.timepicker-list li:hover,
.timepicker-list .ui-timepicker-selected:hover {
    background: #1980EC;
    color: #fff;
}


.timepicker>ul>li:hover {
    background: #ccc;
}

.timepicker>ul>li>a {
    padding: 0 4px;
    display: block;
}
</style>

<script>
// ideas from here: http://stackoverflow.com/questions/152975/how-do-i-detect-a-click-outside-an-element
export default {
    props: ['value', 'inputClass'],
    methods: {
        toggle() {
            this.open = !this.open;
        },
        cancelHide() {
            clearTimeout(this.openTimer);
        },
        show() {
            this.$refs.input.select();
            this.open = true;
        },
        hide() {
            this.openTimer = setTimeout(() => {
                this.open = false;
            }, 0);
        },
        selectHour(time) {
            const value = this.$refs.input.value;
            const parts = value.split(':');
            this.$refs.input.value = time + ':' + (parts[1] || '00');
            this.validate();
        },
        selectMinute(time) {
            const value = this.$refs.input.value;
            const parts = value.split(':');
            if (parts[1]) {
                this.$refs.input.value = parts[0] + ':' + time;
            } else {
                this.$refs.input.value = '10:' + time;
            }
            this.validate();
            this.open = false;
        },
        input() {
            let value = this.$refs.input.value;
            if (this.backspace) {
                if (value.substr(-1) == ':') {
                    this.$refs.input.value = value.substr(0, value.length - 1);
                }
                return;
            }
            if (this.delete) {
                return;
            }
            if (value[value.length - 1] == ':') {
                return;
            }
            if (value.length == 1 && value[0] > 2) {
                this.setValue(value + ':');
                return;
            }
            if (value.length == 2) {
                this.setValue(value + ':');
                return;
            }
            if (value.length == 3 && value[value.length - 2] !== ':') {
                this.setValue(value.substr(0, 2) + ':' + value.substr(-1));
                return;
            }
            if (value.length > 5) {
                this.setValue(this.oldValue);
                return;
            }
            if (value.length > 4 && !valid(value)) {
                this.setValue(this.oldValue);
                return;
            }
            this.setValue(value);

            function valid(time) {
                return time.match(/^[012]?[0-9]:[012345][0-9]$/);
            }
        },
        setValue(value) {
            this.$refs.input.value = value.replace(/[^0-9:]/g, '');
        },
        keydown(event) {
            const charCode = event.which || event.keyCode;
            this.oldValue = this.$refs.input.value;
            this.backspace = charCode == 8;
            this.delete = charCode == 46;
        },
        validate(time) {
            time = time || this.$refs.input.value;
            let parts = time.split(':');
            let hours = !isNaN(parseInt(parts[0])) ? Math.max(Math.min(parseInt(parts[0]), 23), 0) : 0;
            let minutes = (parts[1] && !isNaN(parseInt(parts[1]))) ? Math.max(Math.min(parseInt(parts[1]), 59), 0) : 0;
            // if this.value is null test this
            let date = this.currentDate ? new Date(this.currentDate) : new Date();
            date.setHours(hours);
            date.setMinutes(minutes);
            date.setSeconds(0);
            this.$emit('input', date);
        },
        formatTime: function(hours, minutes) {
            return hours + ':' + ('0' + minutes).substr(-2);
        },
        outsideClick() {
            if (this.preventClosing) {
                return this.preventClosing = false;
            }
            this.open = false;
        }
    },
    data() {
        return {
            preventClosing: false,
            hoursStart: 8,
            oldValue: null,
            currentDate: null,
            open: false,
            openTimer: null,
            minuteSuggestions: [],
            hourSuggestions: [],
        };
    },
    mounted() {
        for (let i = 0; i < 24; i += 1) {
            this.hourSuggestions.push((i + this.hoursStart) % 24);
        }
        for (let i = 0; i < 60; i += 1) {
            this.minuteSuggestions.push(('0' + i).substr(-2));
        }
        this.$refs.dropdownHours.onmousewheel = (e) => {
            this.$refs.dropdownHours.scrollTop -= e.wheelDeltaY;
            e.preventDefault();
        };
        this.$refs.dropdownMinutes.onmousewheel = (e) => {
            this.$refs.dropdownMinutes.scrollTop -= e.wheelDeltaY;
            e.preventDefault();
        };
        if (this.value) {
            this.currentDate = new Date(this.value);
        } else {
            this.currentDate = new Date();
        }
        this.clickHandler = this.outsideClick.bind(this);
        document.addEventListener('click', this.clickHandler, false);
    },
    destroyed() {
        document.removeEventListener('click', this.clickHandler);
    },
    watch: {
        value(value) {
            if (value) {
                this.currentDate = new Date(value);
            }
        },
    },
    computed: {
        time() {
            if (!this.currentDate) {
                return '';
            }
            let date = new Date(this.currentDate);
            return this.formatTime(date.getHours(), date.getMinutes());
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/js/ui/TimePicker.vue